import { getScopedItem, STORAGE_KEYS } from "../components/common/Helper";
import APIConstants from "./APIConstants";
import APIService, { setAuthToken } from "./APIService";
import DebugService from "./DebugService";

/**
 * @description Tag Permissions Api Service
 */
const UserTagPermissionsApiService = {

  /**
   * Get user tag permissions
   * @param {string} userAccountId
   * @param {number} userId
   */
  getTagPermissions: async (userAccountId, userId) => {
    try {
      let url = `${APIConstants.ENDPOINT_GET_TAG_PERMISSIONS}?userAccountId=${userAccountId}&userId=${userId}`;

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN));
      }

      return await APIService.get(url);
    } catch (err) {
      DebugService.error(
        "Tag Permissions Api Service: Error while fetching tag permissions",
        err
      );
    }
  },

  /**
   * Insert or update user tag permissions
   * @param {Object} data
   */
  upsertTagPermissions: async (data) => {
    try {
      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN));
      }

      return await APIService.post(
        APIConstants.ENDPOINT_UPSERT_TAG_PERMISSIONS,
        data
      );
    } catch (err) {
      DebugService.error(
        "Tag Permissions Api Service: Error while upserting tag permissions",
        err
      );
    }
  },

  /**
   * Delete user tag permission
   * @param {number} userTagPermissionId
   */
  deleteTagPermission: async (userTagPermissionId) => {
    try {
      let url = `${APIConstants.ENDPOINT_DELETE_TAG_PERMISSIONS}?userTagPermissionId=${userTagPermissionId}`;

      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN));
      }

      return await APIService.delete(url);
    } catch (err) {
      DebugService.error(
        "Tag Permissions Api Service: Error while deleting tag permission",
        err
      );
    }
  },

  /**
   * Insert or update user service permissions
   * @param {Object} data
   */
  upsertServicePermissions: async (data) => {
    try {
      if (getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN));
      }

      return await APIService.post(
        APIConstants.ENDPOINT_UPSERT_SERVICE_PERMISSIONS,
        data
      );
    } catch (err) {
      DebugService.error(
        "Tag Permissions Api Service: Error while upserting service permissions",
        err
      );
    }
  },
};

export default UserTagPermissionsApiService;